import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import TagsInput from "react-tagsinput";
import Select from "react-select";
import appConfig from "../../config/appConfig";
import {
  filterChannel,
  formatSelectOption,
  formatToTime,
  formatToTimeStampUpdate,
  formatDateToTime,
} from "../../helpers/function";
import { ERROR_401 } from "../../config/errorPage";
import { verifyPermission } from "../../helpers/permission";
import { RESPONSE_CHANNEL } from "../../constants/channel";
import { ToastBottomEnd } from "../components/Toast";
import {
  toastEditErrorMessageConfig,
  toastErrorMessageWithParameterConfig,
  toastSuccessMessageWithParameterConfig,
} from "../../config/toastConfig";
import InputRequire from "./InputRequire";
import InfirmationTable from "./InfirmationTable";
import WithoutCode from "./WithoutCode";
import { verifyTokenExpire } from "../../middleware/verifyToken";
import Loader from "./Loader";
import HtmlDescriptionModal from "./DescriptionDetail/HtmlDescriptionModal";
import HtmlDescription from "./DescriptionDetail/HtmlDescription";
import ClaimerFollowUpModal from "./ClaimerFollowUpModal";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

const endPointConfig = {
  PRO: {
    plan: "PRO",
    edit: (id) => `${appConfig.apiDomaine}/my/claims-incompletes/${id}/edit`,
    update: (id) => `${appConfig.apiDomaine}/my/claims-incompletes/${id}`,
  },
  MACRO: {
    holding: {
      edit: (id) => `${appConfig.apiDomaine}/any/claims-incompletes/${id}/edit`,
      update: (id) => `${appConfig.apiDomaine}/any/claims-incompletes/${id}`,
      relance_client: (id) => `${appConfig.apiDomaine}/any/claims-incompletes/${id}/relance-client`,
    },
    filial: {
      edit: (id) => `${appConfig.apiDomaine}/my/claims-incompletes/${id}/edit`,
      update: (id) => `${appConfig.apiDomaine}/my/claims-incompletes/${id}`,
      relance_client: (id) => `${appConfig.apiDomaine}/my/claims-incompletes/${id}/relance-client`,
    },
  },
  HUB: {
    plan: "HUB",
    edit: (id) => `${appConfig.apiDomaine}/without-client/claims-incompletes/${id}/edit`,
    update: (id) => `${appConfig.apiDomaine}/without-client/claims-incompletes/${id}`,
  },
};

const IncompleteClaimsEdit = (props) => {
  const { t, ready } = useTranslation();

  document.title = ready ? t("Satis client - Complétion plaintes incomplètes") : "";
  const { id } = useParams();

  if (
    !(
      verifyPermission(props.userPermissions, "update-claim-incomplete-against-any-institution") ||
      verifyPermission(props.userPermissions, "update-claim-incomplete-against-my-institution") ||
      verifyPermission(props.userPermissions, "update-claim-incomplete-without-client")
    )
  )
    window.location.href = ERROR_401;

  let endPoint = "";
  if (props.plan === "MACRO") {
    if (verifyPermission(props.userPermissions, "update-claim-incomplete-against-any-institution"))
      endPoint = endPointConfig[props.plan].holding;
    else if (verifyPermission(props.userPermissions, "update-claim-incomplete-against-my-institution"))
      endPoint = endPointConfig[props.plan].filial;
  } else endPoint = endPointConfig[props.plan];

  const defaultData = {
    firstname: null,
    lastname: null,
    sexe: null,
    telephone: [],
    email: [],
    ville: null,
    raison_sociale: "",
    type_client: "",
    unit_targeted_id: null,
    institution_targeted_id: null,
    account_targeted_id: null,
    account_number: null,
    claim_object_id: null,
    request_channel_slug: null,
    response_channel_slug: null,
    claimer_expectation: null,
    description: null,
    amount_currency_slug: null,
    amount_disputed: null,
    claimer_id: null,
    relationship_id: null,
    event_occured_at: null,
    is_revival: 0,
    doublon_to_delete: 0,
    file: [],
    lieu: null,
    prepaid_card_number: "",
    send_mail: 1,
  };

  const defaultError = {
    firstname: [],
    lastname: [],
    sexe: [],
    telephone: [],
    email: [],
    ville: [],
    raison_sociale: [],
    type_client: [],
    unit_targeted_id: [],
    institution_targeted_id: [],
    account_targeted_id: [],
    account_number: [],
    claim_object_id: [],
    claim_category: [],
    request_channel_slug: [],
    response_channel_slug: [],
    claimer_expectation: [],
    description: [],
    amount_currency_slug: [],
    amount_disputed: [],
    claimer_id: [],
    relationship_id: [],
    event_occured_at: [],
    is_revival: [],
    doublon_to_delete: [],
    prepaid_card_number: [],
    send_mail: [],
    file: [],
    lieu: [],
  };

  const option1 = 1;
  const option2 = 0;

  const [activeTab, setActiveTab] = useState("form");
  const [load, setLoad] = useState(true);
  const [claimObject, setClaimObject] = useState(null);
  const [claimObjects, setClaimObjects] = useState([]);
  const [claimCategory, setClaimCategory] = useState(null);
  const [claimCategories, setClaimCategories] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [account, setAccount] = useState(null);
  const [units, setUnits] = useState([]);
  const [unit, setUnit] = useState(null);
  const [responseChannels, setResponseChannels] = useState([]);
  const [channels, setChannels] = useState([]);
  const [relationships, setRelationships] = useState([]);
  const [relationship, setRelationship] = useState(null);
  const [responseChannel, setResponseChannel] = useState(null);
  const [receptionChannel, setReceptionChannel] = useState(null);
  const [currency, setCurrency] = useState(null);
  const [currencies, setCurrencies] = useState([]);
  const [institution, setInstitution] = useState(null);
  const [institutions, setInstitutions] = useState([]);
  const [data, setData] = useState(defaultData);
  const [error, setError] = useState(defaultError);
  const [startRequest, setStartRequest] = useState(false);
  const [isRequire, setIsRequire] = useState(null);
  const [componentData, setComponentData] = useState(undefined);
  const [currentMessage, setCurrentMessage] = useState("");
  const [oldFiles, setOldFiles] = useState([]);
  const [followUpsList, setFollowUpsList] = useState([]);
  const [claimReference, setClaimReference] = useState("");

  const [completionError, setCompletionError] = useState({ ref: "", list: [] });

  const currentDate = new Date();
  currentDate.setHours(currentDate.getHours() + 1);
  const maxDate = currentDate.toISOString().substr(0, currentDate.toISOString().length - 1);

  const extractPrepaidVisibleDigits = (value) => {
    if (!value) return "";
    const raw = value.toString().replace(/\s/g, "");
    if (!raw) return "";
    const digitsOnly = raw.replace(/\D/g, "");
    if (digitsOnly.length <= 10) return digitsOnly;
    return `${digitsOnly.slice(0, 6)}${digitsOnly.slice(-4)}`;
  };

  async function fetchData() {
    await axios.get(endPoint.edit(`${id}`)).then((response) => {
      const claim = response.data.claim;
      setClaimReference(claim?.reference || "");
      setFollowUpsList(claim?.claimer_follow_ups || claim?.claimerFollowUps || []);

      const newIncompleteClaim = {
        claimer_id: claim.claimer_id,
        firstname: claim.claimer?.firstname || "",
        lastname: claim.claimer?.lastname || "",
        sexe: claim.claimer?.sexe || "",
        telephone: claim.claimer?.telephone || [],
        email: claim.claimer?.email || [],
        ville: claim.claimer?.ville || "",
        type_client: claim.claimer?.type_client || "",
        raison_sociale: claim.claimer?.raison_sociale || "",
        unit_targeted_id: claim.unit_targeted_id,
        relationship_id: claim.relationship_id,
        account_targeted_id: claim.account_targeted_id,
        account_number: claim.account_number,
        institution_targeted_id: claim.institution_targeted_id,
        claim_object_id: claim.claim_object_id,
        request_channel_slug: claim.request_channel_slug,
        response_channel_slug: claim.response_channel_slug,
        amount_disputed: claim.amount_disputed || "",
        claimer_expectation: claim.claimer_expectation || "",
        description: claim.description,
        lieu: claim.lieu || null,
        amount_currency_slug: claim.amount_currency_slug || "",
        prepaid_card_number: extractPrepaidVisibleDigits(claim.prepaid_card_number),
        send_mail: typeof claim.send_mail === "number" ? claim.send_mail : 1,
        event_occured_at: formatToTime(claim.event_occured_at),
        is_revival: parseInt(claim.is_revival) === 1 ? 1 : 0,
        doublon_to_delete: parseInt(claim.doublon_to_delete) === 1 ? 1 : 0,
      };

      setData(newIncompleteClaim);
      setIsRequire(response.data.requirements);
      setOldFiles(claim.files || []);

      if (verifyPermission(props.userPermissions, "update-claim-incomplete-without-client"))
        setRelationships(formatSelectOption(response.data.relationships, "name", "fr"));

      setAccounts(response.data.accounts ? formatSelectOption(response.data.accounts, "account_number", false) : []);

      if (
        verifyPermission(props.userPermissions, "update-claim-incomplete-against-any-institution") ||
        verifyPermission(props.userPermissions, "update-claim-incomplete-without-client")
      )
        setInstitutions(formatSelectOption(response.data.institutions, "name", false));

      if (verifyPermission(props.userPermissions, "store-claim-against-my-institution")) {
        setUnits(formatSelectOption(response.data.units, "name", "fr"));
      }

      setClaimCategories(formatSelectOption(response.data.claimCategories, "name", "fr"));
      setCurrencies(formatSelectOption(response.data.currencies, "name", "fr", "slug"));
      setChannels(formatSelectOption(response.data.channels, "name", "fr", "slug"));
      setResponseChannels(formatSelectOption(filterChannel(response.data.channels, RESPONSE_CHANNEL), "name", "fr", "slug"));

      if (claim.request_channel) setReceptionChannel({ value: claim.request_channel.id, label: claim.request_channel.name.fr });
      if (claim.response_channel) setResponseChannel({ value: claim.response_channel.id, label: claim.response_channel.name.fr });
      if (claim.claim_object) setClaimObject({ value: claim.claim_object.id, label: claim.claim_object.name.fr });
      if (claim.claim_object?.claim_category) setClaimCategory({ value: claim.claim_object.claim_category.id, label: claim.claim_object.claim_category.name.fr });
      if (claim.institution_targeted) setInstitution({ value: claim.institution_targeted.id, label: claim.institution_targeted.name });
      if (claim.relationship) setRelationship({ value: claim.relationship.id, label: claim.relationship.name.fr });
      if (claim.amount_currency) setCurrency({ value: claim.amount_currency.id, label: claim.amount_currency.name.fr });
      if (claim.account_targeted) setAccount({ value: claim.account_targeted.id, label: claim.account_targeted.account_number });
      if (claim.unit_targeted) setUnit({ value: claim.unit_targeted.id, label: claim.unit_targeted.name.fr });
    });

    await axios
      .get(appConfig.apiDomaine + "/components/retrieve-by-name/register_claim")
      .then((response) => {
        setComponentData(response.data);
        setLoad(false);
      })
      .catch(() => setLoad(false));
  }

  useEffect(() => {
    if (verifyTokenExpire()) {
      fetchData();
    }
  }, [endPoint, props.userPermissions, id]);

  const onChangeClaimCategory = (selected) => {
    setClaimCategory(selected);
    if (verifyTokenExpire()) {
      axios
        .get(`${appConfig.apiDomaine}/claim-categories/${selected.value}/claim-objects`)
        .then((response) => {
          setClaimObject({});
          setClaimObjects(formatSelectOption(response.data.claimObjects, "name", "fr"));
        })
        .catch(() => {});
    }
  };

  const showModal = (message) => {
    setCurrentMessage(message);
    document.getElementById("button_modal").click();
  };

  const onChangeRelationShip = (selected) => {
    const newData = { ...data, relationship_id: selected ? selected.value : "" };
    setRelationship(selected || null);
    setData(newData);
  };

  const onChangeFirstName = (e) => setData({ ...data, firstname: e.target.value });
  const onChangeLastName = (e) => setData({ ...data, lastname: e.target.value });
  const onChangeSexe = (e) => setData({ ...data, sexe: e.target.value });
  const onChangeVille = (e) => setData({ ...data, ville: e.target.value });
  const onChangeRaisonSociale = (e) => setData({ ...data, raison_sociale: e.target.value });
  const onChangeCustomerType = (e) => setData({ ...data, type_client: e.target.value });
  const onChangeLieu = (e) => setData({ ...data, lieu: e.target.value });
  const onChangeTelephone = (tel) => setData({ ...data, telephone: tel });
  const onChangeEmail = (mail) => setData({ ...data, email: mail });

  const onChangeUnit = (selected) => {
    setUnit(selected);
    setData({ ...data, unit_targeted_id: selected.value !== "other" ? selected.value : "" });
  };

  const onChangeAccount = (selected) => {
    setAccount(selected);
    setData({ ...data, account_targeted_id: selected?.value || null });
  };

  const onChangeAccountNumber = (e) => setData({ ...data, account_number: e.target.value });

  const onChangeClaimObject = (selected) => {
    setClaimObject(selected);
    setData({ ...data, claim_object_id: selected.value });
  };

  const onChangeReceptionChannel = (selected) => {
    setReceptionChannel(selected);
    setData({ ...data, request_channel_slug: selected.value });
  };

  const onChangeResponseChannel = (selected) => {
    setResponseChannel(selected);
    setData({ ...data, response_channel_slug: selected.value });
  };

  const onChangeClaimerExpectation = (e) => setData({ ...data, claimer_expectation: e.target.value });
  const onChangeDescription = (e) => setData({ ...data, description: e.target.value });

  const formatPrepaidCardForInput = (rawValue) => {
    const digits = (rawValue || "").toString().replace(/\D/g, "").slice(0, 10);
    if (!digits) return "";
    const chars = [];
    for (let i = 0; i < 16; i++) {
      if (i < 6) chars[i] = digits[i] || "";
      else if (i < 12) chars[i] = "*";
      else chars[i] = digits[6 + (i - 12)] || "";
    }
    return `${chars.slice(0, 4).join("")} ${chars.slice(4, 8).join("")} ${chars.slice(8, 12).join("")} ${chars.slice(12, 16).join("")}`.trimEnd();
  };

  const onChangePrepaidCard = (e) => {
    const inputValue = e.target.value;
    const prevDigits = (data.prepaid_card_number || "").toString().replace(/\D/g, "").slice(0, 10);
    let digits = inputValue.replace(/\D/g, "").slice(0, 10);

    if (digits === prevDigits && prevDigits.length > 0 && inputValue.length < formatPrepaidCardForInput(prevDigits).length) {
      digits = prevDigits.slice(0, -1);
    }
    setData({ ...data, prepaid_card_number: digits });
  };

  const onChangeAmountDisputed = (e) => setData({ ...data, amount_disputed: e.target.value });

  const onChangeAmountCurrency = (selected) => {
    setCurrency(selected || null);
    setData({ ...data, amount_currency_slug: selected ? selected.value : "" });
  };

  const onChangeEventOccuredAt = (e) => {
    if (new Date(e.target.value) >= new Date()) {
      ToastBottomEnd.fire(toastErrorMessageWithParameterConfig(t("Date invalide")));
      setData({ ...data, event_occured_at: "" });
    } else setData({ ...data, event_occured_at: e.target.value });
  };

  const handleOptionChange = (e) => setData({ ...data, is_revival: parseInt(e.target.value) });
  const handleDoublonChange = (e) => setData({ ...data, doublon_to_delete: parseInt(e.target.value) });
  const handleSendMailChange = (e) => setData({ ...data, send_mail: parseInt(e.target.value) });
  const onChangeFile = (e) => setData({ ...data, file: Object.values(e.target.files) });

  const formatFormData = (newData) => {
    const formData = new FormData();
    formData.append("_method", "put");
    for (const key in newData) {
      if (key === "file") {
        for (let i = 0; i < newData.file.length; i++) formData.append("file[]", newData[key][i], newData[key][i].name);
      } else if (key === "telephone") {
        for (let i = 0; i < newData.telephone.length; i++) formData.append("telephone[]", newData[key][i]);
      } else if (key === "email") {
        for (let i = 0; i < newData.email.length; i++) formData.append("email[]", newData[key][i]);
      } else formData.set(key, newData[key]);
    }
    return formData;
  };

  const downloadReceipt = async (claim_id) => {
    const institutionPrintReceiptEndpoint = `${appConfig.apiDomaine}/download-claim-receipt`;
    if (verifyTokenExpire()) {
      setLoad(true);
      await axios.get(`${institutionPrintReceiptEndpoint}/${claim_id}`, { responseType: "blob" }).then((response) => {
        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute("download", "receipt.pdf");
        document.body.appendChild(fileLink);
        fileLink.click();
        setLoad(false);
      });
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const newData = { ...data };

    if (data.prepaid_card_number) {
      const digits = data.prepaid_card_number.replace(/\D/g, "");
      if (digits.length !== 10) {
        setError({
          ...error,
          prepaid_card_number: [t("Le format de la carte prépayée est invalide (10 chiffres requis : 6 premiers et 4 derniers).")],
        });
        setStartRequest(false);
        return;
      } else {
        newData.prepaid_card_number = `${digits.slice(0, 6)}******${digits.slice(6)}`;
      }
    }

    if (typeof data.type_client == "undefined") {
      newData.type_client = "Physique";
      newData.raison_sociale = "";
    }

    setStartRequest(true);
    newData.event_occured_at = formatToTimeStampUpdate(data.event_occured_at);

    if (!newData.response_channel_slug) delete newData.response_channel_slug;
    if (!newData.unit_targeted_id) delete newData.unit_targeted_id;
    if (!newData.account_targeted_id) delete newData.account_targeted_id;
    if (!newData.account_number) delete newData.account_number;
    if (!newData.prepaid_card_number) delete newData.prepaid_card_number;
    if (!newData.amount_disputed) delete newData.amount_disputed;
    if (!newData.amount_currency_slug) delete newData.amount_currency_slug;
    if (!verifyPermission(props.userPermissions, "update-claim-incomplete-without-client")) delete newData.relationship_id;

    if (verifyTokenExpire()) {
      axios
        .post(endPoint.update(`${id}`), formatFormData(newData))
        .then(async (response) => {
          setStartRequest(false);
          if (newData.doublon_to_delete) {
            ToastBottomEnd.fire(toastSuccessMessageWithParameterConfig(t("Réclamation marquée comme doublon avec succès")));
            window.location.href = "/process/incomplete_claims";
          }
          if (response.data.status == "full") {
            if (newData.send_mail == 0) await downloadReceipt(`${id}`);
            ToastBottomEnd.fire(toastSuccessMessageWithParameterConfig(t("Succès de la complétion")));
            window.location.href = "/process/incomplete_claims";
          } else {
            ToastBottomEnd.fire(toastSuccessMessageWithParameterConfig("Modifications enregistrées mais la réclamation est toujours incomplète"));
            setCompletionError({
              ref: response.data.claim.reference,
              list: response.data.errors,
            });
            if (verifyTokenExpire()) fetchData();
          }
        })
        .catch((error) => {
          setStartRequest(false);
          if (error.response?.data?.code === 422) {
            let fileErrors = [];
            let claimerExpectationError = null;
            let i = 0;
            for (const key in error.response.data.error) {
              if (key === `file.${i}`) {
                fileErrors = [...fileErrors, ...error.response.data.error[`file.${i}`]];
                i++;
              }
              if (key === "claimer_expectation") {
                claimerExpectationError = error.response.data.error.claimer_expectation;
              }
            }
            setError({
              ...defaultError,
              ...error.response.data.error,
              file: fileErrors,
              claim_category: claimCategory === null ? ["Le champ claim_category est obligatoire."] : [],
              claimer_expectation: claimerExpectationError != null ? [claimerExpectationError] : [],
            });
            ToastBottomEnd.fire(toastEditErrorMessageConfig);
          }
        });
    }
  };

  const sortedFollowUps = [...followUpsList].sort((a, b) => {
    const dateA = new Date(a.created_at || a.follow_up_date || 0);
    const dateB = new Date(b.created_at || b.follow_up_date || 0);
    return dateB - dateA;
  });

  if (!ready) return null;

  return load ? (
    <Loader />
  ) : (
    <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor" id="kt_content">
      <div className="kt-subheader kt-grid__item" id="kt_subheader">
        <div className="kt-container kt-container--fluid">
          <div className="kt-subheader__main">
            <h3 className="kt-subheader__title">{t("Collecte")}</h3>
            <span className="kt-subheader__separator kt-hidden" />
            <div className="kt-subheader__breadcrumbs">
              <a href="#icone" className="kt-subheader__breadcrumbs-home">
                <i className="flaticon2-shelter" />
              </a>
              <span className="kt-subheader__breadcrumbs-separator" />
              <span className="kt-subheader__breadcrumbs-link">{t("Réclamations Incomplètes")}</span>
              <span className="kt-subheader__breadcrumbs-separator" />
              <span className="kt-subheader__breadcrumbs-link">{t("Complétion")}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
        <InfirmationTable
          information={t("Formulaire d'enregistrement et suivi d'une réclamation incomplète.")}
        />

        {/* CONTAINER ONGLETS METRONIC */}
        <div className="kt-portlet kt-portlet--tabs">
          <div className="kt-portlet__head">
            <div className="kt-portlet__head-label">
              <h3 className="kt-portlet__head-title">
                {t("Dossier N°")} <span className="text-primary">{claimReference || `#${id}`}</span>
              </h3>
            </div>
            <div className="kt-portlet__head-toolbar">
              <ul className="nav nav-tabs nav-tabs-line nav-tabs-line-danger nav-tabs-line-2x nav-tabs-line-right">
                <li className="nav-item">
                  <button
                    type="button"
                    className={`nav-link ${activeTab === "form" ? "active" : ""}`}
                    onClick={() => setActiveTab("form")}
                  >
                    <i className="la la-edit"></i> {t("Complétion du Formulaire")}
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    type="button"
                    className={`nav-link ${activeTab === "history" ? "active" : ""}`}
                    onClick={() => setActiveTab("history")}
                  >
                    <i className="la la-history"></i> {t("Historique des relances")}{" "}
                    <span className="badge badge-warning ml-2 font-weight-bold">
                      {sortedFollowUps.length}
                    </span>
                  </button>
                </li>
              </ul>
            </div>
          </div>

          <div className="kt-portlet__body">
            {/* ONGLET 1 : FORMULAIRE DE COMPLÉTION */}
            {activeTab === "form" && (
              <form method="POST" className="kt-form">
                {/* Section Institution */}
                {(verifyPermission(props.userPermissions, "update-claim-incomplete-against-any-institution") ||
                  verifyPermission(props.userPermissions, "update-claim-incomplete-without-client")) && (
                  <div className={error.institution_targeted_id.length ? "form-group row validated" : "form-group row"}>
                    <label className="col-xl-3 col-lg-3 col-form-label" htmlFor="institution">
                      {componentData ? componentData.params.fr.institution.value : ""} <InputRequire />
                    </label>
                    <div className="col-lg-9 col-xl-6">
                      <Select
                        classNamePrefix="select"
                        className="basic-single"
                        placeholder={componentData ? componentData.params.fr.institution_placeholder.value : ""}
                        value={institution}
                        options={institutions}
                      />
                      {error.institution_targeted_id.length
                        ? error.institution_targeted_id.map((err, index) => (
                            <div key={index} className="invalid-feedback">{err}</div>
                          ))
                        : null}
                    </div>
                  </div>
                )}

                {/* Info Cible / Réclamant */}
                <div className="kt-section kt-section--first">
                  <div className="kt-section__body">
                    <h3 className="kt-section__title kt-section__title-lg">
                      {componentData ? componentData.params.fr.info_cible.value + ":" : ""}
                    </h3>

                    {/* Type client */}
                    <div className="form-group row">
                      <div className={error.type_client.length ? "form-group col validated" : "form-group col"}>
                        <label htmlFor="customer-type">
                          Type de client <InputRequire />
                        </label>
                        <select
                          disabled={true}
                          id="customer-type"
                          className={error.type_client.length ? "form-control is-invalid" : "form-control"}
                          value={data.type_client || "Physique"}
                          onChange={onChangeCustomerType}
                        >
                          <option value="Physique">{t("Personne physique")}</option>
                          <option value="Moral">{t("Personne morale")}</option>
                        </select>
                      </div>
                    </div>

                    {(typeof data.type_client === "undefined" || data?.type_client === "Physique") && (
                      <div className="form-group row">
                        <div className={error.lastname.length ? "col validated" : "col"}>
                          <label htmlFor="lastname">
                            {componentData ? componentData.params.fr.nom.value : ""} <InputRequire />
                          </label>
                          <input
                            id="lastname"
                            type="text"
                            className={error.lastname.length ? "form-control is-invalid" : "form-control"}
                            value={data.lastname}
                            onChange={onChangeLastName}
                          />
                        </div>
                        <div className={error.firstname.length ? "col validated" : "col"}>
                          <label htmlFor="firstname">
                            {componentData ? componentData.params.fr.prenoms.value : ""} <InputRequire />
                          </label>
                          <input
                            id="firstname"
                            type="text"
                            className={error.firstname.length ? "form-control is-invalid" : "form-control"}
                            value={data.firstname}
                            onChange={onChangeFirstName}
                          />
                        </div>
                      </div>
                    )}

                    {data?.type_client === "Moral" && (
                      <div className="form-group row">
                        <div className={error.raison_sociale.length ? "form-group col validated" : "form-group col"}>
                          <label htmlFor="raison_sociale">
                            Raison Sociale <InputRequire />
                          </label>
                          <input
                            id="raison_sociale"
                            type="text"
                            className={error.raison_sociale.length ? "form-control is-invalid" : "form-control"}
                            value={data.raison_sociale}
                            onChange={onChangeRaisonSociale}
                          />
                        </div>
                        <div className={error.ville.length ? "col validated" : "col"}>
                          <label htmlFor="ville">{componentData ? componentData.params.fr.ville.value : ""}</label>
                          <input
                            id="ville"
                            type="text"
                            className={error.ville.length ? "form-control is-invalid" : "form-control"}
                            value={data.ville}
                            onChange={onChangeVille}
                          />
                        </div>
                      </div>
                    )}

                    {(typeof data.type_client === "undefined" || data?.type_client === "Physique") && (
                      <div className="form-group row">
                        <div className={error.sexe.length ? "form-group col validated" : "form-group col"}>
                          <label htmlFor="sexe">
                            {componentData ? componentData.params.fr.sexe.value : ""} <InputRequire />
                          </label>
                          <select
                            id="sexe"
                            className={error.sexe.length ? "form-control is-invalid" : "form-control"}
                            value={data.sexe}
                            onChange={onChangeSexe}
                          >
                            <option value="">--</option>
                            <option value="F">{t("Féminin")}</option>
                            <option value="M">{t("Masculin")}</option>
                            <option value="A">{t("Autres")}</option>
                          </select>
                        </div>
                        <div className={error.ville.length ? "col validated" : "col"}>
                          <label htmlFor="ville">{componentData ? componentData.params.fr.ville.value : ""}</label>
                          <input
                            id="ville"
                            type="text"
                            className={error.ville.length ? "form-control is-invalid" : "form-control"}
                            value={data.ville}
                            onChange={onChangeVille}
                          />
                        </div>
                      </div>
                    )}

                    {/* Téléphone & Email */}
                    <div className="form-group row">
                      <div className={error.telephone.length ? "col validated" : "col"}>
                        <label htmlFor="telephone">
                          {componentData ? componentData.params.fr.telephone.value : ""} <WithoutCode /> <InputRequire />
                        </label>
                        <TagsInput value={data.telephone} onChange={onChangeTelephone} />
                      </div>
                      <div className={error.email.length ? "col validated" : "col"}>
                        <label htmlFor="email">
                          {componentData ? componentData.params.fr.email.value : ""} <InputRequire />
                        </label>
                        <TagsInput value={data.email} onChange={onChangeEmail} />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="kt-separator kt-separator--border-dashed kt-separator--space-lg" />

                {/* Info Réclamation */}
                <div className="kt-section">
                  <div className="kt-section__body">
                    <h3 className="kt-section__title kt-section__title-lg">
                      {componentData ? componentData.params.fr.info_reclamation.value : ""}
                    </h3>

                    {!verifyPermission(props.userPermissions, "update-claim-incomplete-without-client") && (
                      <div className="form-group row">
                        <div className={error.unit_targeted_id.length ? "col validated" : "col"}>
                          <label htmlFor="unit">
                            {componentData ? componentData.params.fr.unite.value : ""}{" "}
                            {isRequire?.unit_targeted_id && <InputRequire />}
                          </label>
                          <Select
                            classNamePrefix="select"
                            className="basic-single"
                            value={unit}
                            onChange={onChangeUnit}
                            options={units}
                          />
                        </div>
                        <div className={error.account_targeted_id.length || error.account_number.length ? "col validated" : "col"}>
                          <label htmlFor="account">
                            {componentData ? componentData.params.fr.compte.value : ""}{" "}
                            {isRequire?.account_targeted_id && <InputRequire />}
                          </label>
                          {accounts.length ? (
                            <Select
                              classNamePrefix="select"
                              className="basic-single"
                              value={account}
                              onChange={onChangeAccount}
                              options={accounts}
                            />
                          ) : (
                            <input
                              id="account-incomplete"
                              type="text"
                              className={error.account_number.length ? "form-control is-invalid" : "form-control"}
                              value={data.account_number || ""}
                              onChange={onChangeAccountNumber}
                            />
                          )}
                        </div>
                      </div>
                    )}

                    {/* Canaux */}
                    <div className="form-group row">
                      <div className={error.request_channel_slug.length ? "col validated" : "col"}>
                        <label htmlFor="receptionChannel">
                          {componentData ? componentData.params.fr.canal_reception.value : ""} <InputRequire />
                        </label>
                        <Select
                          classNamePrefix="select"
                          className="basic-single"
                          value={receptionChannel}
                          onChange={onChangeReceptionChannel}
                          options={channels}
                        />
                      </div>
                      <div className={error.response_channel_slug.length ? "col validated" : "col"}>
                        <label htmlFor="responseChannel">
                          {componentData ? componentData.params.fr.canal_reponse.value : ""} <InputRequire />
                        </label>
                        <Select
                          classNamePrefix="select"
                          className="basic-single"
                          value={responseChannel}
                          onChange={onChangeResponseChannel}
                          options={responseChannels}
                        />
                      </div>
                    </div>

                    {/* Catégories / Objets / Lieu */}
                    <div className="form-group row">
                      <div className={error.claim_category.length ? "col validated" : "col"}>
                        <label htmlFor="claimCategory">
                          {componentData ? componentData.params.fr.categorie.value : ""} <InputRequire />
                        </label>
                        <Select
                          classNamePrefix="select"
                          className="basic-single"
                          value={claimCategory}
                          onChange={onChangeClaimCategory}
                          options={claimCategories}
                        />
                      </div>
                      <div className={error.claim_object_id.length ? "col validated" : "col"}>
                        <label htmlFor="claimObject">
                          {componentData ? componentData.params.fr.object.value : ""} <InputRequire />
                        </label>
                        <Select
                          classNamePrefix="select"
                          className="basic-single"
                          value={claimObject}
                          onChange={onChangeClaimObject}
                          options={claimObjects}
                        />
                      </div>
                      <div className={error.lieu.length ? "col validated" : "col"}>
                        <label htmlFor="lieu">{componentData ? componentData.params.fr.lieu.value : ""}</label>
                        <input
                          id="lieu"
                          type="text"
                          className={error.lieu.length ? "form-control is-invalid" : "form-control"}
                          value={data.lieu || ""}
                          onChange={onChangeLieu}
                        />
                      </div>
                    </div>

                    {/* Montant & Devise */}
                    <div className="form-group row">
                      <div className={error.amount_disputed.length ? "col validated" : "col"}>
                        <label htmlFor="amount_claim">
                          {componentData ? componentData.params.fr.montant.value : ""}{" "}
                          (<strong className="text-danger">{t("Laisser vide si pas de montant")}</strong>){" "}
                          {isRequire?.amount_disputed && <InputRequire />}
                        </label>
                        <input
                          type="number"
                          min="0"
                          id="amount_claim"
                          className={error.amount_disputed.length ? "form-control is-invalid" : "form-control"}
                          value={data.amount_disputed}
                          onChange={onChangeAmountDisputed}
                        />
                      </div>
                      <div className={error.amount_currency_slug.length ? "col validated" : "col"}>
                        <label htmlFor="currency">
                          {componentData ? componentData.params.fr.devise.value : ""}{" "}
                          {isRequire?.amount_currency_slug && <InputRequire />}
                        </label>
                        <Select
                          isClearable
                          classNamePrefix="select"
                          className="basic-single"
                          value={currency}
                          onChange={onChangeAmountCurrency}
                          options={currencies}
                        />
                      </div>
                    </div>

                    {/* Carte prépayée */}
                    <div className="form-group row">
                      <div className={error.prepaid_card_number.length ? "col validated" : "col"}>
                        <label htmlFor="prepaid_card_number">{t("Carte prépayée")}</label>
                        <div className="input-group">
                          <div className="input-group-prepend">
                            <span className="input-group-text"><i className="fa fa-credit-card" /></span>
                          </div>
                          <input
                            type="text"
                            id="prepaid_card_number"
                            className={error.prepaid_card_number.length ? "form-control is-invalid" : "form-control"}
                            value={formatPrepaidCardForInput(data.prepaid_card_number)}
                            onChange={onChangePrepaidCard}
                          />
                        </div>
                      </div>
                    </div>

                    {/* Date d'incident & Relation */}
                    <div className="form-group row">
                      <div className={error.event_occured_at.length ? "col validated" : "col"}>
                        <label htmlFor="date">
                          {componentData ? componentData.params.fr.date.value : ""} <InputRequire />
                        </label>
                        <input
                          type="datetime-local"
                          id="date"
                          className={error.event_occured_at.length ? "form-control is-invalid" : "form-control"}
                          value={data.event_occured_at}
                          max={maxDate}
                          onChange={onChangeEventOccuredAt}
                        />
                      </div>
                      {verifyPermission(props.userPermissions, "update-claim-incomplete-without-client") && (
                        <div className={error.relationship_id.length ? "col validated" : "col"}>
                          <label htmlFor="relationship">
                            {componentData ? componentData.params.fr.relation.value : ""}{" "}
                            {isRequire?.relationship_id && <InputRequire />}
                          </label>
                          <Select
                            isClearable
                            value={relationship}
                            onChange={onChangeRelationShip}
                            options={relationships}
                          />
                        </div>
                      )}
                      <div className="col">
                        <label htmlFor="file">
                          {componentData && componentData.params.fr.piece.value}
                          {isRequire?.file && <InputRequire />}
                        </label>
                        <input
                          onChange={onChangeFile}
                          type="file"
                          className={error.file.length ? "form-control is-invalid" : "form-control"}
                          id="customFile"
                          multiple={true}
                        />
                        {oldFiles?.length > 0 && (
                          <div className="kt-margin-t-10">
                            {oldFiles.map((f, idx) => (
                              <a key={idx} href={`${appConfig.apiDomaine}${f.url}`} download={true} target="_blank" rel="noopener noreferrer" className="mr-2 d-inline-block">
                                {f.title}
                              </a>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Description & Attentes */}
                    <div className="form-group row">
                      <div className={error.description.length ? "col validated" : "col"}>
                        <label htmlFor="description">
                          {componentData ? componentData.params.fr.description.value : ""}
                          {isRequire?.description && <InputRequire />}
                        </label>
                        {data.request_channel_slug === "email" ? (
                          <HtmlDescription onClick={(e) => { e.preventDefault(); showModal(data.description || "-"); }} />
                        ) : (
                          <textarea
                            rows="5"
                            id="description"
                            className={error.description.length ? "form-control is-invalid" : "form-control"}
                            value={data.description}
                            onChange={onChangeDescription}
                          />
                        )}
                      </div>
                      <div className={error.claimer_expectation.length ? "col validated" : "col"}>
                        <label htmlFor="claimer_expectation">
                          {componentData ? componentData.params.fr.attente.value : ""}
                          {isRequire?.claimer_expectation && <InputRequire />}
                        </label>
                        <textarea
                          rows="5"
                          id="claimer_expectation"
                          className={error.claimer_expectation.length ? "form-control is-invalid" : "form-control"}
                          value={data.claimer_expectation}
                          onChange={onChangeClaimerExpectation}
                        />
                      </div>
                    </div>

                    {/* Récépissé */}
                    <div className="form-group row">
                      <div className={error.send_mail.length ? "col validated" : "col"}>
                        <label className="d-block">{t("Envoyer le récépissé ?")}</label>
                        <div className="kt-radio-inline mt-2">
                          <label className="kt-radio">
                            <input type="radio" value={1} onChange={handleSendMailChange} checked={data.send_mail === 1} /> {t("Oui")} <span />
                          </label>
                          <label className="kt-radio">
                            <input type="radio" value={0} onChange={handleSendMailChange} checked={data.send_mail === 0} /> {t("Non")} <span />
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="kt-separator kt-separator--border-dashed kt-separator--space-lg" />

                {/* Relance radio */}
                <div className="kt-section">
                  <div className="kt-section__body">
                    <h3 className="kt-section__title kt-section__title-lg">
                      {componentData ? componentData.params.fr.last_titre.value : ""} <InputRequire />
                    </h3>
                    <div className="form-group row">
                      <label className="col-3 col-form-label">{componentData ? componentData.params.fr.question.value : ""}</label>
                      <div className="col-9">
                        <div className="kt-radio-inline">
                          <label className="kt-radio">
                            <input type="radio" value={option1} onChange={handleOptionChange} checked={option1 == data.is_revival} /> {componentData ? componentData.params.fr.reponse_oui.value : ""} <span />
                          </label>
                          <label className="kt-radio">
                            <input type="radio" value={option2} onChange={handleOptionChange} checked={option2 == data.is_revival} /> {componentData ? componentData.params.fr.reponse_non.value : ""} <span />
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="kt-separator kt-separator--border-dashed kt-separator--space-lg" />

                {/* Doublon radio */}
                <div className="kt-section">
                  <div className="kt-section__body">
                    <h3 className="kt-section__title kt-section__title-lg">Doublon <InputRequire /></h3>
                    <div className="form-group row">
                      <label className="col-3 col-form-label">Est-ce un doublon à enlever ?</label>
                      <div className="col-9">
                        <div className="kt-radio-inline">
                          <label className="kt-radio">
                            <input type="radio" value={option1} onChange={handleDoublonChange} checked={option1 == data.doublon_to_delete} /> Oui <span />
                          </label>
                          <label className="kt-radio">
                            <input type="radio" value={option2} onChange={handleDoublonChange} checked={option2 == data.doublon_to_delete} /> Non <span />
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Alertes d'incomplétion */}
                {completionError.list.length > 0 && (
                  <div className="alert alert-warning fade show mt-4" role="alert">
                    <div className="alert-icon"><i className="flaticon-warning" /></div>
                    <div className="alert-text">
                      <p><b>{completionError.ref}:</b> {t("La réclamation est toujours incomplète")}</p>
                      <ul className="ml-4 mb-0">
                        {completionError.list.map((el, index) => (
                          <li key={index}>- {el.description["fr"]}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}

                {/* Actions du bas de formulaire */}
                <div className="kt-portlet__foot mt-4">
                  <div className="kt-form__actions text-right">
                    {(props.userPermissions.length === 0 || verifyPermission(props.userPermissions, "follow-up-claimer")) && (
                      <button
                        type="button"
                        className="btn btn-warning mr-3 font-weight-bold"
                        data-toggle="modal"
                        data-target="#claimerFollowUpModal"
                        disabled={startRequest}
                      >
                        <i className="flaticon2-paper-plane mr-2" /> {t("Relance")}
                      </button>
                    )}

                    {!startRequest ? (
                      <button type="submit" onClick={onSubmit} className="btn btn-primary font-weight-bold">
                        {t("Modifier")}
                      </button>
                    ) : (
                      <button className="btn btn-primary kt-spinner kt-spinner--left kt-spinner--md kt-spinner--light" type="button" disabled>
                        {t("Chargement")}...
                      </button>
                    )}

                    <Link to="/process/incomplete_claims" className="btn btn-secondary mx-3">
                      {t("Quitter")}
                    </Link>
                  </div>
                </div>
              </form>
            )}

            {/* ONGLET 2 : HISTORIQUE DES RELANCES */}
            {activeTab === "history" && (
              <div className="follow-ups-history-container">
                <div className="d-flex align-items-center justify-content-between mb-4 pb-3 border-bottom">
                  <div>
                    <h5 className="font-weight-bold text-dark m-0">
                      <i className="la la-history text-primary mr-2" />
                      {t("Fil chronologique des relances et actions")}
                    </h5>
                    <small className="text-muted">
                      {t("Consultez l'historique complet des échanges et relances effectués sur ce dossier.")}
                    </small>
                  </div>
                  {(props.userPermissions.length === 0 || verifyPermission(props.userPermissions, "follow-up-claimer")) && (
                    <button
                      type="button"
                      className="btn btn-warning btn-sm font-weight-bold"
                      data-toggle="modal"
                      data-target="#claimerFollowUpModal"
                    >
                      <i className="flaticon2-paper-plane mr-1" />
                      {t("Effectuer une relance")}
                    </button>
                  )}
                </div>

                {sortedFollowUps.length > 0 ? (
                  sortedFollowUps.map((item, idx) => {
                    const staffName = item.staff
                      ? `${item.staff.firstname || ""} ${item.staff.lastname || ""}`.trim() || item.staff.identite?.firstname || "-"
                      : "-";

                    return (
                      <div className="card mb-3 border-left-warning shadow-sm" key={item.id || idx}>
                        <div className="card-header bg-light py-2 px-3 d-flex align-items-center justify-content-between">
                          <span className="badge badge-warning font-weight-bold">
                            <i className="la la-paper-plane mr-1" />
                            {t("Relance #")}{sortedFollowUps.length - idx}
                          </span>
                          <small className="text-muted font-weight-bold">
                            {formatDateToTime(item.follow_up_date || item.created_at)}
                          </small>
                        </div>
                        <div className="card-body p-3">
                          {item.message && (
                            <p className="text-dark mb-2" style={{ whiteSpace: "pre-wrap" }}>
                              {item.message}
                            </p>
                          )}
                          <div className="d-flex align-items-center text-muted small mt-2">
                            <i className="la la-user mr-1 text-primary" />
                            <span>
                              {t("Effectuée par")} : <strong className="text-dark">{staffName}</strong>
                            </span>
                          </div>

                          {item.files && item.files.length > 0 && (
                            <div className="mt-3 pt-2 border-top">
                              <span className="font-weight-bold small text-dark d-block mb-1">
                                <i className="la la-paperclip mr-1 text-primary" />
                                {t("Pièces jointes")} :
                              </span>
                              <div className="d-flex flex-wrap">
                                {item.files.map((file, fIdx) => (
                                  <a
                                    key={file.id || fIdx}
                                    href={file.url?.startsWith("http") ? file.url : `${appConfig.apiDomaine}${file.url}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-xs btn-outline-primary mr-2 mb-1"
                                  >
                                    <i className="flaticon2-file mr-1" />
                                    {file.title || file.name || `${t("Fichier")} #${fIdx + 1}`}
                                  </a>
                                ))}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="alert alert-light text-center py-5 text-muted mb-4 border">
                    <i className="la la-info-circle display-4 d-block mb-2 text-muted" />
                    {t("Aucune relance enregistrée pour le moment sur cette réclamation.")}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        {/* MODALE BOOTSTRAP DE RELANCE */}
        <ClaimerFollowUpModal
          claimId={id}
          onSuccess={() => fetchData()}
        />

        <button
          id="button_modal"
          type="button"
          className="btn btn-secondary btn-icon-sm d-none"
          data-toggle="modal"
          data-target="#message_email"
        />
        <HtmlDescriptionModal title={t("Description")} message={currentMessage} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    userPermissions: state.user.user.permissions,
    plan: state.plan.plan,
  };
};

export default connect(mapStateToProps)(IncompleteClaimsEdit);